export default __webpack_public_path__ + "static/kjackson-5557099da860d9c83373309c6a384f43.jpg";